import { anodum, hdrm, view } from '@yola/ws-sdk';

const buildPictureElement = (imageAttributes) => {
  const liveDocument = view.accessors.getLiveDocument();
  const { defaultView } = liveDocument;
  const mediaTemplates = defaultView.customElements
    .get(hdrm.constants.IMAGE_SELECTOR)
    .getTemplates();
  const mediaContainer = mediaTemplates.pictureContainer(imageAttributes);

  return anodum.parseElementFromString(mediaContainer);
};

export default buildPictureElement;
